import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { AuthService } from 'src/app/service/auth.service';
import { SystemService } from 'src/app/service/system.service';
import { FileService } from 'src/app/service/file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-basic-data',
  templateUrl: './basic-data.component.html',
  styleUrls: ['./basic-data.component.scss']
})
//(change)="createUserChange()" (submit)="createUserSubmit()"
export class BasicDataComponent implements OnInit {
  currentDate = new Date();
  showLoader: boolean = false;
  creating: boolean = false;
  url: string = "";
  // imageUrl: any = "https://gravatar.com/avatar/ae4e3e608c9496ff0a04d46b0304cbe8?s=400&d=robohash&r=x";
  imageUrl: any = "assets/images/stud-image.png";
  uploadImage: any;
  countries: any;
  regions: any;
  provinces: any;
  city: any;
  maritalStatus: any;
  milStatus: any;
  userImageFile: any;
  userImageFileName: any;

  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth() + 1;
  day = this.now.getDay();
  // minDate = moment({year: this.year - 100, month: this.month, day: this.day}).format('YYYY-MM-DD');
  minDate = (this.year - 40) + "-" + ("0" + this.month).slice(-2) + "-" + ("0" + this.day).slice(-2);

  // maxDate = moment({year: this.year - 16, month: this.month, day: this.day}).format('YYYY-MM-DD');
  maxDate = (this.year - 16) + "-" + ("0" + this.month).slice(-2) + "-" + ("0" + this.day).slice(-2);

  // UUID
  uuid: any;

  currentLang: string = "en";

  checkPhoneValue: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    // console.log(control.value);
    // console.log(this.basicData.controls.personalMobile1.value);
    let phone1 = group.get('personalMobile1')?.value;
    let phone2 = group.get('emergencyMobile1')?.value;
    // let phone1 = "";
    // let phone2 = "";
    // console.log("phone1:" + phone1);
    // console.log("phone2:" + phone2);

    return phone1 && phone2 && phone1 === phone2 ? { samePhone: true } : null
  }

  basicData = new FormGroup({
    candCode: new FormControl(''),
    natId: new FormControl(''),
    userEmail: new FormControl(''),
    bachelorCert: new FormControl(''),
    bachelorCard: new FormControl(''),
    fullNameArabic: new FormControl('', [
      Validators.required,
    ]),
    fullNameEnglish: new FormControl('', [
      Validators.required,
    ]),
    address1En: new FormControl('', [
      Validators.required,
    ]),
    // address1Ar: new FormControl('', [
    //   Validators.required,
    // ]),
    // address2En: new FormControl('', [
    //   Validators.required,
    // ]),
    // address2Ar: new FormControl('', [
    //   Validators.required,
    // ]),
    country: new FormControl('', [
      Validators.required,
    ]),
    region: new FormControl('', [
      Validators.required,
    ]),
    province: new FormControl('', [
      Validators.required,
    ]),
    city: new FormControl('', [
      Validators.required,
    ]),
    maritalStatus: new FormControl('', [
      Validators.required,
    ]),
    personalMobile1: new FormControl('', [
      Validators.required,
      Validators.maxLength(11),
      Validators.minLength(11),
      Validators.pattern('[0][1](1|2|5|0)[0-9]{8}'),

    ]),
    personalMobile2: new FormControl('', [
      // Validators.required,

      Validators.maxLength(11),
      Validators.minLength(11),
      Validators.pattern('[0][1](1|2|5|0)[0-9]{8}'),
    ]),
    emergencyMobile1: new FormControl('', [
      Validators.required,
      Validators.maxLength(11),
      Validators.minLength(11),
      Validators.pattern('[0][1](1|2|5|0)[0-9]{8}'),
    ]),
    emergencyMobile2: new FormControl('', [
      // Validators.required,
      Validators.maxLength(11),
      Validators.minLength(11),
      Validators.pattern('[0][1](1|2|5|0)[0-9]{8}'),
    ]),
    emergencyContact1: new FormControl('', [
      Validators.required,
    ]),
    emergencyContact2: new FormControl('', [
      // Validators.required,
    ]),
    militaryStatus: new FormControl('', [
      Validators.required,
    ]),
    homePhone: new FormControl('', [
      // Validators.required,
      Validators.pattern('[0-9]{7,11}'),
    ]),
    englishNotes: new FormControl('', [
      // Validators.required,
    ]),
    // arabicNotes: new FormControl('', [
    //   // Validators.required,
    // ]),
    userImage: new FormControl('', [
      Validators.required,
    ]),
    dateOfBirth: new FormControl('', [
      Validators.required,
    ]),
    gender: new FormControl('', [
      Validators.required,
    ]),
  }, this.checkPhoneValue);
  constructor(private admService: AdmService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService,
    public activatedRoute: ActivatedRoute, public router: Router,
    private systemService: SystemService,
    public translate: TranslateService, private fileService: FileService, private authService: AuthService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.uuid = params['UUID'] || "";

        if (this.uuid != "") {
          this.validateCandByUuid(this.uuid);

        } else {
          this.toastr.error(this.translate.instant('CAN_NOT_FIND_UUID'));
          this.router.navigate(['/home']);
        }
      });
    this.currentLang = this.globals.lang;
  }

  changeLang(lang: string) {
    // console.log("test : " + this.loginForm.controls.lang.value);
    this.currentLang = lang;
    this.globals.changeLang(this.currentLang);
    // setTimeout(() => {
    //   console.log('sleep');
    //   this.translate.use(this.currentLang);
    //   // And any other code that should run only after 1s
    // }, 1000);
    this.translate.use(this.currentLang);

  }

  getRegionsByCountryId() {
    this.systemService.getRegionsByCountryId(this.basicData.controls.country.value).subscribe(
      data => {
        this.regions = data
        console.log("countries" + this.regions);
        // this.toastr.success("Basic Data Saved successfully");
      },
      error => {
        //this.creating = false
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      },
      //() => this.creating = false

    );
  }
  getProvinciesByRegionId() {
    this.systemService.getProvincesByCountryIdAndRegionId(this.basicData.controls.country.value, this.basicData.controls.region.value).subscribe(
      data => {
        this.provinces = data
        console.log("countries" + this.provinces);
        // this.toastr.success("Basic Data Saved successfully");
      },
      error => {
        //this.creating = false
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      },
      //() => this.creating = false

    );
  }
  getcitiesByProvinceId() {
    this.systemService.getCitiesByCountryIdAndRegionIdAndProvinceId(this.basicData.controls.country.value, this.basicData.controls.region.value, this.basicData.controls.province.value).subscribe(
      data => {
        this.city = data
        console.log("countries" + this.city);
        // this.toastr.success("Basic Data Saved successfully");
      },
      error => {
        //this.creating = false
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      },
      //() => this.creating = false

    );
  }
  basicDataSubmit() {
    this.creating = true;
    console.log("befor valid");
    if (this.basicData.valid) {
      console.log("in valid");
      this.creating = true;
      this.handleUploadFile();
    }
    else {
      console.log("non valid");
      this.basicData.markAllAsTouched();
      this.basicData.markAsDirty();
      this.creating = false;
    }
  }

  basicDataChange() {

  }

  userChangeImage(event: any) {
    let typesAccept = ['image/png', 'image/jpeg', 'image/jpg'];
    // Max size 200 MEGA
    var maxSize = 209715200;
    if (event.target.files.length > 0) {
      var currentFile = event.target.files[0];
      console.log("file type: " + currentFile.type);

      // if ((currentFile.type == oldExcel || currentFile.type == excel) && currentFile.size <= maxSize) {
      if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
        this.userImageFile = event.target.files[0];
        var reader = new FileReader();

        reader.readAsDataURL(currentFile); // read file as data url

        reader.onload = (event) => { // called once readAsDataURL is completed
          this.imageUrl = event.target?.result;
        }
        this.uploadImage = currentFile;
        console.log("accepted extention");
        return true;
      } else {
        console.log(currentFile.type);
        console.log("wrong extention");
        this.basicData.controls.userImage.reset();
        this.uploadImage = '';
        this.basicData.controls.userImage.markAsDirty();
        this.basicData.controls.userImage.markAsTouched();
        if (currentFile.size > maxSize) {
          this.toastr.error(this.translate.instant('MAX_FILE_SIZE_200_MB'));
        }
        return false;
      }
    }
    else {
      return false;
    }
  }

  getAllCountries() {
    this.systemService.getAllCountries()
      .subscribe(
        data => {
          this.countries = data;
        },
        error => {
          this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getAllMilstatus() {
    this.admService.getMilStatus()
      .subscribe(
        data => {
          this.milStatus = data;
        },
        error => {
          this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getAllMaritalStatus() {
    this.admService.getMaritalStatus()
      .subscribe(
        data => {
          this.maritalStatus = data;
        },
        error => {
          this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  changeCountry() {
    console.log("coun  : ")
    console.log(this.basicData.controls.country.value);
    this.getRegionsByCountryId();
  }
  changeRegion() {
    console.log("rejion  : ")
    console.log(this.basicData.controls.region.value);
    this.getProvinciesByRegionId();
  }
  changeProvince() {
    console.log("ptov  : ")
    console.log(this.basicData.controls.province.value);
    this.getcitiesByProvinceId();
  }
  changeCity() {
    console.log(this.basicData.controls.city.value);
  }

  getCandById(candId: number) {
    this.admService.getCandidateById(candId).subscribe(
      data => {
        // console.log(data.nidNo);
        // nidNo
        // emailAddress1
        // bachlorCertFilename
        // bachlorCardFilename
        // candCode: new FormControl(''),

        // natId: new FormControl(''),
        // userEmail: new FormControl(''),
        // bachelorCert: new FormControl(''),
        // bachelorCard: new FormControl(''),
        this.basicData.controls.candCode.setValue(data.candCode);
        this.basicData.controls.natId.setValue(data.nidNo);
        this.basicData.controls.userEmail.setValue(data.emailAddress1);
        this.basicData.controls.bachelorCert.setValue(data.bachlorCertFilename);
        this.basicData.controls.bachelorCard.setValue(data.bachlorCardFilename);
        this.basicData.controls.fullNameArabic.setValue(data.fullNameAr);
        this.basicData.controls.fullNameEnglish.setValue(data.fullNameEn);
      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }
  getCandNewCode() {
    this.admService.getCandNewCode(this.globals.orgId).subscribe(
      data => {
        // console.log(data.nidNo);
        // nidNo
        // emailAddress1
        // bachlorCertFilename
        // bachlorCardFilename
        // candCode: new FormControl(''),
        this.basicData.controls.candCode.setValue(data);
      },
      error => {
        console.log(error);
        console.log(error.error);
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }
  changegender() {
    console.log(this.basicData.controls.gender.value);
  }

  updateCandBasicData() {
    let addressEnglish = ""
    let addressArabic = ""
    let noteEnglish = ""
    let noteArabic = ""
    if (this.globals.lang == "en") {
      addressEnglish = this.basicData.controls.address1En.value;
      noteEnglish = this.basicData.controls.englishNotes.value;

    } else {
      addressArabic = this.basicData.controls.address1En.value;
      noteArabic = this.basicData.controls.englishNotes.value;
    }

    this.admService.addbasicData(this.globals.candidateId,
      this.basicData.controls.fullNameArabic.value,
      this.basicData.controls.fullNameEnglish.value,
      this.basicData.controls.dateOfBirth.value,
      addressArabic,
      addressEnglish,
      "",
      "",
      this.basicData.controls.personalMobile1.value,
      this.basicData.controls.personalMobile2.value,
      this.basicData.controls.emergencyMobile1.value,
      this.basicData.controls.emergencyMobile2.value,
      this.basicData.controls.homePhone.value,
      noteArabic,
      noteEnglish,
      this.userImageFileName,
      this.basicData.controls.militaryStatus.value,
      this.basicData.controls.country.value,
      this.basicData.controls.region.value,
      this.basicData.controls.province.value,
      this.basicData.controls.city.value,
      this.basicData.controls.maritalStatus.value,
      this.basicData.controls.gender.value,
      this.currentDate
    )
      .subscribe(
        data => {
          this.router.navigate(['/admission/section1']);
          this.toastr.success(this.translate.instant('ADDED_SUCCESSFULLY'));
        },
        error => {
          this.creating = false
          this.toastr.error(this.translate.instant('FAIL_TO_CREATE'));
        },
        () => this.creating = false
      );
  }

  handleUploadFile() {
    let formData = new FormData();

    let fname = this.userImageFile.name.split('.').slice(0, -1).join('.')
    let fext = this.userImageFile.name.split('.').pop()
    this.userImageFileName = fname + "_" + Date.now() + "." + fext
    formData.append('file', this.userImageFile, this.userImageFileName);

    this.fileService.uploadFile(formData).subscribe(
      data => {
        this.updateCandBasicData()
      },
      error => {
        this.creating = false
        this.toastr.warning(this.translate.instant("CAN_NOT_UPLOAD_USER_IMAGE"));
      }
    );
  }

  validateCandByUuid(uuid: string) {
    this.showLoader = true
    this.authService.validateCandByUuid(uuid).subscribe(
      data => {
        this.globals.candidateId = data.candidateid;
        this.getAllCountries();
        this.getAllMaritalStatus();
        this.getAllMilstatus();
        // Static cand ID tell finish API
        this.getCandById(this.globals.candidateId);
        // this.getCandById(this.globals.candidateId);
        // this.getCandNewCode();
      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        this.router.navigate(['/home']);
      },
      () => this.showLoader = false
    );
  }

}
